import { render } from "./BlockUser_modal.vue?vue&type=template&id=45befbb0"
import script from "./BlockUser_modal.vue?vue&type=script&lang=js"
export * from "./BlockUser_modal.vue?vue&type=script&lang=js"

import "./BlockUser_modal.vue?vue&type=style&index=0&id=45befbb0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__